import { FORT_AGENT_STATUS, type MyFortAgentItem } from "@/api/types";
import { formatEther } from "viem";

export type MyAgentsFilter = "all" | "activated" | "pending";

export function filterMyAgents(
  agents: MyFortAgentItem[],
  filter: MyAgentsFilter
): MyFortAgentItem[] {
  if (filter === "all") return agents;
  if (filter === "activated") {
    return agents.filter(a => a.status === FORT_AGENT_STATUS.ACTIVATED);
  }
  return agents.filter(a => a.status === FORT_AGENT_STATUS.PENDING);
}

export function computeMyAgentsStats(agents: MyFortAgentItem[]) {
  const activatedCount = agents.filter(
    a => a.status === FORT_AGENT_STATUS.ACTIVATED
  ).length;
  const pendingCount = agents.filter(
    a => a.status === FORT_AGENT_STATUS.PENDING
  ).length;
  const totalWei = agents.reduce(
    (sum, a) => sum + BigInt(a.priceBasisUsdt || 0),
    0n
  );
  const totalInvestment = Number(formatEther(totalWei));

  return {
    total: agents.length,
    activatedCount,
    pendingCount,
    totalInvestment,
  };
}
